import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class ReportfileApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'reportfile'
    }

   
    /**
     * 报表内容保存
     * @param params 
     * @returns 
     */
    public uploadXml(params){
        return this.send(params,"uploadXml",Methods.POST)
    }

   
}